import { useState } from 'react';
import { Alert, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/shared/auth';
import { AddPaymentMethodButton } from '@/features/subscription/add-payment-method';

const SESSION_DISMISS_KEY = 'paywall-banner-dismissed-session';

export const FreeROsRemainingBanner = () => {
  const { t } = useTranslation();
  const { sessionUser } = useAuth();
  const [dismissed, setDismissed] = useState<boolean>(() => {
    return sessionStorage.getItem(SESSION_DISMISS_KEY) === 'true';
  });

  const sub = sessionUser?.subscription;
  if (!sub || sub.tier !== 'free' || sub.paymentMethodOnFile || sub.freeRosUnlimited) {
    return null;
  }
  if (sub.freeRosRemaining !== 1 && sub.freeRosRemaining !== 2) {
    return null;
  }
  if (dismissed) {
    return null;
  }

  const handleDismiss = () => {
    sessionStorage.setItem(SESSION_DISMISS_KEY, 'true');
    setDismissed(true);
  };

  const messageKey =
    sub.freeRosRemaining === 1 ? 'subscription.freeRosBanner.oneLeft' : 'subscription.freeRosBanner.twoLeft';
  const severity = sub.freeRosRemaining === 1 ? 'warning' : 'info';

  return (
    <Alert
      severity={severity}
      onClose={handleDismiss}
      closeText={t('subscription.freeRosBanner.dismissAria')}
      sx={{ alignItems: 'center' }}
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
        <span>{t(messageKey)}</span>
        <AddPaymentMethodButton variant="outlined" size="small">
          {t('subscription.freeRosBanner.addPaymentMethod')}
        </AddPaymentMethodButton>
      </Stack>
    </Alert>
  );
};
